module.exports = __webpack_public_path__ + "static/logo-1e07f8c123fc4750e0afc6f2f53b8d06.gif";